<div class="p-4 lg:p-10 flex-1 flex flex-col">
  <div class="hidden md:flex items-center justify-end gap-6"></div>
  <div class="welcome flex flex-col gap-6 py-6">
    <div class="font-efSans-secondary font-semibold uppercase">
      {{ 'customer-portal' | sharedTranslate }}
    </div>
    <div class="font-canelablack-primary text-4xl md:text-5xl">
      <T
        str="Please add your vehicle details"
        key="customerPortal.kc.vin-validation.title"
        tags="kc-forms, 3.6"
      ></T>
    </div>
    <div
      class="text-mat-ef-revolution-primary-500 font-efSans text-xl font-light"
    >
      <T
        str="To complete your registration we need VIN number of your active owned vehicle. Please insert VIN number bellow and click continue."
        key="customerPortal.kc.vin-validation.text"
        tags="kc-forms, 3.6"
      ></T>
    </div>

    <mat-error
      *ngIf="validationError"
      class="text-mat-ef-revolution-primary-500"
    >
      <mat-divider></mat-divider>
      <div class="py-4 px-0">
        <T
          str="Unfortunately, the VIN you entered cannot be verified at the moment. Please check your entry."
          key="customerPortal.kc.vin-validation.error"
          tags="kc-forms, 3.5"
        ></T>
      </div>
      <mat-divider></mat-divider>
    </mat-error>
  </div>
  <div class="form-container">
    <form
      #vinValidationForm
      [formGroup]="form"
      method="POST"
      [action]="viewData.registrationAction"
      (ngSubmit)="submit()"
      class="grid"
    >
      <div class="grid grid-cols-1">
        <mat-form-field class="md:max-w-[300px]">
          <mat-label>
            <T
              str="Vehicle identification number (VIN)"
              key="customerPortal.kc.vin-validation.vin"
              tags="kc-forms, 3.6"
            ></T>
          </mat-label>
          <input
            class="input"
            matInput
            required
            formControlName="vin"
            name="vin"
            oninput="this.value = this.value.toUpperCase()"
          />
          <mat-icon
            *ngIf="form.controls.vin.touched && form.controls.vin.invalid"
            matSuffix
            color="error"
            svgIcon="error_outline"
          ></mat-icon>
          <mat-error *ngIf="form.controls.vin.invalid">
            {{
              transifexService.getErrorTranslation(
                form.controls.vin,
                'customerPortal.kc.vin-validation.error.vin.'
              )
            }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex gap-4 flex-col md:flex-row mt-4">
        <input type="hidden" name="step" value="vin_validation" />
        <input type="hidden" name="skip" value="{{ skipVinValidation }}" />
        <button
          mat-button
          mat-stroked-button
          color="secondary"
          type="submit"
          (click)="
            skipVinValidation = true; submittingButton = 'skip'; submit()
          "
          [disabled]="submitting"
          class="revolution w-full lg:w-1/2 button-spinner"
        >
          <customer-portal-ef-spinner
            [color]="'mat-ef-revolution-grey-two-500'"
            [opacity]="0.7"
            [diameter]="16"
            *ngIf="submitting && submittingButton === 'skip'"
          >
          </customer-portal-ef-spinner>
          <div>
            {{ 'skip' | sharedTranslate }}
          </div>
        </button>

        <button
          mat-button
          mat-raised-button
          color="secondary"
          type="submit"
          (click)="
            skipVinValidation = false; submittingButton = 'next'; submit()
          "
          [disabled]="!form.valid || submitting || notValid"
          class="revolution w-full lg:w-1/2 button-spinner"
        >
          <customer-portal-ef-spinner
            [color]="'mat-ef-revolution-grey-two-500'"
            [opacity]="0.7"
            [diameter]="16"
            *ngIf="submitting && submittingButton === 'next'"
          >
          </customer-portal-ef-spinner>
          <div>
            {{ 'next' | sharedTranslate }}
          </div>
        </button>
      </div>
    </form>
  </div>
</div>
